import { DialogOverlay, DialogOverlayFooter, DialogOverlayActions, Button, TextField } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { addCmisReference } from '../../../services/personService'
import useNotifications from '../../../hooks/useNotifications'
import { DotSeparator } from '../../metadata/MetaData'

export default function CmisRefAddDialog({ personDetails, onSubmit, ...opener }) {
  const { error, ok } = useNotifications()
  const [mrn, setMrn] = useState()
  const [personId, setPersonId] = useState()
  const { t } = useTranslation()

  const isValidMrn = () => {
    if (!mrn) {
      return undefined
    }
    const mrnRegexp = /^[0-9]{12}[0-9A]{1}$/
    return mrnRegexp.test(mrn)
  }

  const isInvalidMrn = () => {
    if (!mrn) {
      return undefined
    }
    return !isValidMrn()
  }

  const addButtonDisabled = personDetails ? !mrn : !mrn || !personId || isInvalidMrn()

  useEffect(() => {
    if (!opener.isOpen && !opener.transitioning) {
      setMrn()
      setPersonId()
    }
  }, [opener.isOpen, opener.transitioning])

  const handleAdds = () => {
    addCmisReference(personDetails ? personDetails.copyPersonId : personId, mrn)
      .then(() => {
        ok(t('person.cmis.successCreatingCmisReference', 'Success creating CMIS Reference'))
        onSubmit()
      })
      .catch((err) => {
        error(
          t('person.cmis.error.addingCmisReferences', {
            defaultValue: `Error adding a CMIS references: ${err.message || ''}`,
            message: err.message || '',
          }),
          err
        )
      })
  }
  if (!onSubmit) {
    return null
  }

  const onChangeTypeMrn = (event) => {
    setMrn(event.target.value)
  }

  return (
    <DialogOverlay {...opener} title={t('person.reference.addCmisReference', 'Add CMIS Reference')}>
      {personDetails ? (
        <>
          {personDetails.copyPersonName}
          <DotSeparator />
          {personDetails.copyPersonId}
        </>
      ) : (
        <TextField
          title={t('personId', 'Person ID')}
          label={t('personId', 'Person ID')}
          onChange={(e) => setPersonId(e.target.value)}
          value={personId}
        />
      )}
      <TextField
        id="mrnInput"
        title={t('mrn', 'MRN')}
        label={t('mrn', 'MRN')}
        onChange={(event) => onChangeTypeMrn(event)}
        value={mrn}
        validMessage={isValidMrn() ? 'Valid MRN' : undefined}
        errorMessage={isInvalidMrn() ? 'Invalid MRN' : undefined}
      />

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button id="confirmAddReferenceBtn" emphasis="high" onClick={handleAdds} disabled={addButtonDisabled}>
            {t('action.add', 'Add')}
          </Button>
          <Button emphasis="medium" onClick={opener.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
